import * as api from '@/api'
import * as http from '@/libs/http'

export default {
  namespaced: true,

  state: {
    token: '',
    errors: []
  },
  getters: {
    token (state) {
      return state.token
    },

    hasError (state) {
      return state.errors.length > 0
    },

    errors (state) {
      return state.errors
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },

    setErrors (state, errors) {
      state.errors = errors || []
    }
  },
  actions: {
    async newToken ({ state, commit }) {
      // API でアクセストークンを取得する
      const resp = await api.newToken()
      if (resp.status !== http.OK) {
        return false
      }

      // アクセストークンを設定する
      commit('setToken', resp.data.token)

      // アクセストークンを取得したことを返す
      return true
    }
  }
}
